<template>
    <div id="demo-form">
        <div v-show="loader" style="margin-top: -10px;">
            <Loader />
        </div>
        <div class="datepickerwrap mx-4">
            <div class="card mt-5">
                <ul class="d-inline-flex align-items-center tabs my-3 pl-0 border-bottom" style="gap: 24px;">
                    <li v-for="section of sections" :key="section" class="cursor-pointer font-lg font-weight-bold px-2"
                        :class="selectedSection === section ? 'activeSectionText' : 'deactiveTextColor'"
                        @click="setPageSelection(section)">{{ section }}</li>
                </ul>
                <div class="mx-2 mt-3">
                    <div class="stepper-section">Step {{ sections.indexOf(selectedSection) + 1 }} of {{ sections.length }}</div>
                    <component :is="componentMapper[selectedSection]" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FeaturesPage from './Sections/FeaturesPage.vue';
import PlatformsPage from './Sections/PlatformsPage.vue';
import ProductsPage from './Sections/ProductsPage.vue';
import ProductReview from './Sections/ProductReview.vue';
import FrequencyPage from './Sections/FrequencyPage.vue';
import CatAndSearchTerms from './Sections/CatAndSearchTerms.vue';
import Pincodes from './Sections/Pincodes.vue';
import Loader from '../../Components/Loader.vue';
export default {
    name: "DemoForm",
    components: {
        Loader,
        FeaturesPage,
        PlatformsPage,
        ProductsPage,
        ProductReview,
        FrequencyPage,
        CatAndSearchTerms,
        Pincodes
    },
    data() {
        return {
            componentMapper: {
                "Features": FeaturesPage,
                "Platforms": PlatformsPage,
                "Products": ProductsPage,
                "Product Review": ProductReview,
                "Frequency": FrequencyPage,
                "Category & Search Terms": CatAndSearchTerms,
                "Pincodes": Pincodes
            },
        }
    },
    computed: {
        ...mapState("DemoStore", ['loader', 'totalFeatures', 'sections', 'selectedSection'])
    },
    mounted() {
        this.getFeatures();
    },
    methods: {
        ...mapActions("DemoStore", ['setDemoLoader', 'setTotalFeatures', 'setSelectedFeatures', 'setSelectedSection']),
        getFeatures() {
            this.setDemoLoader(true);
            this.setTotalFeatures(null);
            const url = "/api/demo/feature";
            this.$http.get(url).then(res => {
                let features = res.body.data.data;
                let selectedFeats = features.filter(feat => feat.isSelected && feat);

                this.setTotalFeatures(features);
                this.setSelectedFeatures(selectedFeats);
                this.setSelectedSection("Features");
                this.setDemoLoader(false);

            }).catch(err => {
                console.log("error in getting features", err);
                this.setDemoLoader(false);
            })
        },
        setPageSelection(section) {
            this.setSelectedSection(section)
        }
    }
}
</script>

<style scoped>
.stepper-section {
    color: var(--primary_brand);
    font-size: 16px;
    font-weight: 600;
    margin-block: 10px 20px;
}

.tabs {
    list-style: none;
}

.activeSectionText {
    color: var(--primary_brand) !important;
    padding-bottom: 11px;
    border-bottom: .07rem solid var(--primary_brand) !important;
}

.deactiveTextColor {
    color: #536387 !important;
    padding-bottom: 10px !important;
}

.cursor-pointer {
    cursor: pointer !important;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
    padding: 16px 32px !important;
}
</style>